import { createVNode as _createVNode, mergeProps as _mergeProps } from "vue";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { computed, defineComponent } from 'vue';
import { VxeButton } from 'vxe-pc-ui';
import { MgDivider } from '../mg-divider';
import './mg-toolbar-styles.less';
export default defineComponent({
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: ['itemClick', 'itemDropdownClick'],
  setup(props, {
    emit
  }) {
    const reactData = reactive({
      items: []
    });
    watch(() => props.items, val => {
      const rawVal = toRaw(unref(val));
      if (rawVal && Array.isArray(rawVal)) {
        reactData.items = (rawVal || []).filter(v => !!v);
      }
    }, {
      immediate: true,
      deep: true
    });
    const handleButtonClick = (item, e) => {
      const {
        onClick
      } = item;
      emit('itemClick', {
        item,
        $event: e
      });
      !!onClick && onClick();
    };
    const handleBtnDropdownClick = (item, option, e) => {
      const {
        onDropdownClick
      } = item;
      const {
        onClick
      } = option;
      emit('itemDropdownClick', {
        item,
        option,
        $event: e
      });
      if (onClick && typeof onClick === 'function') {
        onClick({
          item,
          $event: e
        });
      } else if (onDropdownClick && typeof onDropdownClick === 'function') {
        onDropdownClick({
          item,
          option,
          $event: e
        });
      }
      !!onDropdownClick && onDropdownClick({
        item,
        option,
        $event: e
      });
    };
    const createBooleanProp = b => {
      return computed(() => {
        if (typeof b === 'function') {
          return b();
        }
        return !!b;
      });
    };
    return () => {
      return _createVNode("div", {
        "class": "mg-ui-toolbar-wrapper"
      }, [reactData.items.map(item => {
        if (item && typeof item === 'string' && item === '--') {
          return _createVNode(MgDivider, {
            "vertical": false
          }, null);
        }
        if (item && typeof item === 'function') {
          return item();
        }
        if (item && typeof item === 'object') {
          const {
            name,
            title,
            onClick,
            icon = '',
            status = '',
            options,
            permissionCode,
            disabled,
            loading
          } = item;
          const btnDisabled = createBooleanProp(disabled);
          const btnLoading = createBooleanProp(loading);
          const btnSlots = {
            default: () => {
              if (typeof title === 'function') {
                return title();
              }
              return title;
            },
            icon: () => {
              if (typeof icon === 'string') {
                return _createVNode("i", {
                  "class": icon
                }, null);
              }
              return icon;
            }
          };
          if (!title || !name && !onClick && !options) return null;
          if (!!options && Array.isArray(options) && options.length > 0) {
            const btnOptions = (options || []).map(opt => {
              const {
                title: optionTitle,
                icon: optionIcon,
                loading: optionLoading,
                disabled: optionDisabled,
                ...more
              } = opt;
              const btnOptionLoading = typeof optionLoading === 'function' ? optionLoading() : !!optionLoading;
              const btnOptionDisabled = typeof optionDisabled === 'function' ? optionDisabled() : !!optionDisabled;
              const btnOptionSlots = {
                default: () => {
                  let sTitle = optionTitle;
                  if (typeof optionTitle === 'function') {
                    sTitle = optionTitle;
                  }
                  return _createVNode("span", {
                    "style": "display:flex; flex-direction: row; align-items: center; justify-content: center;"
                  }, [_createVNode("span", {
                    "style": "display: inline-block; width: 24px; height: 100%"
                  }, [!!optionIcon && (typeof optionIcon === 'string' ? _createVNode("i", {
                    "class": optionIcon
                  }, null) : typeof optionIcon === 'function' || typeof optionIcon === 'object' ? optionIcon : null)]), _createVNode("span", {
                    "style": "display: inline-block; flex: 1; text-align: left; padding: 0 5px;"
                  }, [sTitle])]);
                }
              };
              return _createVNode(VxeButton, _mergeProps({
                "loading": btnOptionLoading,
                "disabled": btnOptionDisabled,
                "onClick": $event => handleBtnDropdownClick(item, opt, $event)
              }, more, {
                "round": false,
                "mode": "text"
              }), btnOptionSlots);
            });
            btnSlots.dropdowns = () => {
              return btnOptions;
            };
            return _createVNode(VxeButton, {
              "options": btnOptions,
              "tansfer": true,
              "status": status,
              "icon": icon,
              "permissionCode": permissionCode,
              "disabled": btnDisabled.value,
              "loading": btnLoading.value
            }, btnSlots);
          }
          return _createVNode(VxeButton, {
            "status": status,
            "icon": icon,
            "disabled": btnDisabled.value,
            "loading": btnLoading.value,
            "permissionCode": permissionCode,
            "onClick": e => handleButtonClick(item, e)
          }, btnSlots);
        }
        return null;
      })]);
    };
  }
});